var map = {
	"./fangsong.ttf": 5519,
	"./hei.ttf": 9492,
	"./kai.ttf": 7551,
	"./shufa.ttf": 8535,
	"./song.ttf": 7745,
	"./xingkai.ttf": 5919,
	"./yuanti.ttf": 2096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8169;